export const FLAG_GETTING_CURRENCY_RATE = 'FLAG_GETTING_CURRENCY_RATE';
export const GET_CURRENCY_RATE = 'GET_CURRENCY_RATE';
export const CLEAR_CURRENCY_RATE = 'CLEAR_CURRENCY_RATE';
